import React, { useState } from 'react';
import './Messaging.css';
import Back from "../components/Back";
import DynamicIsland from '../components/DynamicIsland';
import CurrentTime from '../components/CurrentTime';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Messaging() {
    const chats = [
        {
          id: 1,
          name: 'Study Group',
          avatar: './img/towson-tiger.png',
          lastMessage: 'Don’t forget the meeting at 3 PM!',
          lastMessageTime: '2:45 PM',
        },
        {
          id: 2,
          name: 'Roommates',
          avatar: './img/towson-tiger.png',
          lastMessage: 'Can someone clean the kitchen today?',
          lastMessageTime: '1:10 PM',
        },
        {
          id: 3,
          name: 'CS Classmates',
          avatar: './img/towson-tiger.png',
          lastMessage: 'Did you finish the project yet?',
          lastMessageTime: 'Yesterday',
        },
        {
          id: 4,
          name: 'Towson Club',
          avatar: './img/towson-tiger.png',
          lastMessage: 'See you all at the event!',
          lastMessageTime: '3 days ago',
        },
      ];

      const handleNewChat = () => {
        alert('Testing');
      };

  return (
    <div className="messaging-container">
        <CurrentTime/>
        <DynamicIsland/>
        <Back/>
        <form className="search-form-messaging">
          <input
            type="search"
            className="search-input"
            placeholder="Search classes or assignments..."
            aria-label="Search classes or assignments"
          />
        </form>
        
        <div className="chats-list">
        {chats.map((chat) => (
          <div key={chat.id} className="chat-item">
            <img src={chat.avatar} alt={chat.name} className="chat-avatar" />
            <div className="chat-details">
              <h3 className="chat-name">{chat.name}</h3>
              <p className="chat-last-message">{chat.lastMessage}</p>
            </div>
            <p className="chat-time">{chat.lastMessageTime}</p>
          </div>
        ))}
              <button className="new-chat-button" onClick={handleNewChat}>
        <FontAwesomeIcon icon={faPenToSquare}/>
      </button>
      </div>
    </div>
  );
}

export default Messaging;